/**
 * @file 输出区组件
 * @author FranckChen(chenfan02@baidu.com)
 */

import React, {memo, useCallback} from 'react';
import {crlf} from 'eol';
import AnsiUp from 'ansi_up';
import createDomPurify from 'dompurify';
import { getTextInfo } from './../../../../../../utils/getTextInfo';

// component
import ExecuteResult from './ExecuteResult';

import {IOutput} from '../../types/codeCell';

interface IProps {
    output: IOutput;
}

const Output: React.FC<IProps> = memo(function (props) {
    const output = props.output;
    const outputType = output.output_type;
    const ansiUp = new AnsiUp();

    const d = useCallback(html => {
        const purifier = createDomPurify(window);
        return {
            __html: purifier.sanitize(html, {
                ADD_ATTR: ['target']
            })
        };
    }, []);

    return (
        <div className="ai-np-output-wrapper">
            {(() => {
                switch (outputType) {
                    case 'stream':
                        const textRaw: string = crlf(output.text?.join('') ?? '');
                        const getProps = getTextInfo(d(ansiUp.ansi_to_html(textRaw)).__html);
                        return (
                            <pre
                                className="ai-np-output-stream"
                                {...getProps}
                            />
                        );
                    case 'error':
                        const errorRaw: string = crlf(output.traceback?.join('') ?? '');
                        const getErrorProps = getTextInfo(d(ansiUp.ansi_to_html(errorRaw)).__html);
                        return (
                            <div className="ai-np-output-error">
                                <pre {...getErrorProps} />
                            </div>
                        );
                    case 'display_data':
                    case 'execute_result':
                        return (<ExecuteResult output={output} />);
                    default:
                        return null;
                }
            })()}
        </div>
    );
});

export default Output;
